<h2 class="m-0" mat-dialog-title *ngIf="data">Abbonamenti di {{data.user.userName}}</h2>
<mat-dialog-content class="mat-typography">
  <div id="main-content" class="row mt-3">
    <div class="col-md-5">
      <form [formGroup]="form" *ngIf="form">
        <mat-form-field appearance="outline">
          <input type="text" placeholder="Prodotto" matInput formControlName="product"
            [matAutocomplete]="subscriptions">
          <mat-autocomplete autoActiveFirstOption #subscriptions="matAutocomplete">
            <mat-option *ngFor="let subscription of filteredSubscriptionsNames | async" [value]="subscription">
              {{subscription}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Prezzo (€)</mat-label>
          <input type="string" matInput formControlName="price" placeholder="Formato es. 200,45 €">
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Tipo Prodotto</mat-label>
          <input type="string" matInput formControlName="type">
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Durata (giorni)</mat-label>
          <input type="string" matInput formControlName="life">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Data Inserimento</mat-label>
          <input matInput [matDatepicker]="insertingDatePicker" formControlName="insertingDate" readonly>
          <mat-datepicker-toggle matSuffix [for]="insertingDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #insertingDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Data Scadenza</mat-label>
          <input matInput [matDatepicker]="expirationDatePicker" formControlName="expirationDate" readonly>
          <mat-datepicker-toggle matSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #expirationDatePicker disabled="false"></mat-datepicker>
        </mat-form-field>
      </form>
      <div class="d-flex justify-content-center p-3" *ngIf="loader.isActive()">
        <app-loader></app-loader>
      </div>
      <div class="text-center" *ngIf="form && !loader.isActive()">
        <button class="mr-5" mat-flat-button color="primary" (click)="assignSubscription()"
          [disabled]="form.invalid">Assegna</button>
        <button class="ml-5" mat-flat-button color="primary" (click)="resetForm()">Annulla</button>
      </div>
    </div>
    <div class="col-md-7">

      <div class="alert cedlab-info" role="alert" *ngIf="data.userBuyings.length === 0">
        {{'Nessun abbonamento trovato'}}
      </div>

      <div class="overflow-auto" *ngIf="data.userBuyings.length > 0">
          <form [formGroup]="subscriptionsForm">
        <table class="subscription-table">
          <thead>
            <tr>
              <th>Prodotto</th>
              <th>Data Acquisto</th>
              <th>Scadenza</th>
              <th>Prezzo</th>
              <th></th>
            </tr>
          </thead>
          <tbody formGroupName="dates" >
            <tr *ngFor="let buying of data.userBuyings; let i = index" [formGroupName]="i">
                <input formControlName="id" type="number" [hidden]="true">
              <td>{{buying.productName}}</td>
              <td>
                <div class="row">
                          <mat-form-field style="max-width:95px;">
                          <input matInput formControlName="purchaseDate"
                            [matDatepicker]="purchaseDatePicker" readonly>
                          <mat-datepicker #purchaseDatePicker></mat-datepicker>
                          <mat-datepicker-toggle matSuffix [for]="purchaseDatePicker"></mat-datepicker-toggle>
                      </mat-form-field>

                      <a style="margin-top: 16px;" *ngIf="hasPurchaseDateChanged(i)" (click)="resetPurchaseDate(i)"><i class="fa fa-undo"></i></a>
                        </div>
                </td>
              <td>
                <div class="row">

                  <mat-form-field style="max-width:95px;">
                    <input matInput formControlName="expirationDate"
                    [matDatepicker]="expirationDatePicker" readonly>
                    <mat-datepicker #expirationDatePicker></mat-datepicker>
                    <mat-datepicker-toggle matSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
                  </mat-form-field>
                  <a style="margin-top: 16px;"  *ngIf="hasExpirationDateChanged(i)" (click)="resetExpirationDate(i)"><i class="fa fa-undo"></i></a>
                </div>
                </td>
              <td>{{buying.productPrice | currency:'EUR'}}</td>
              <td>
                  <i (click)="updateUserBuyingDates(i)" *ngIf="hasSubscriptionBeenEdited(i)" style="display: inline; cursor:pointer; margin-right:5px;" class="fa fa-check-square"></i>
                  <a style="display: inline;" (click)="openSubscriptionDialog(buying.id)"><i style="display: inline;" class="fa fa-trash"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
    </form>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="pt-5 pb-4">
  <button mat-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>